module.exports = __webpack_public_path__ + "img/patient-record-desktop-ru.255f8377.jpg";